// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phases-fair-play-settings__container {
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    background: var(--white-color);
    margin-top: 16px;
}

.phases-fair-play-settings__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--new-gray-background-color);
    padding: 8px 16px;
    position: relative;
}

.phases-fair-play-settings__header .baloa-normal-medium {
    color: var(--primary-very-dark-color);
}

.phases-fair-play-settings__header .hubicon-add_option {
    color: unset;
    margin-right: 4px;
    font-size: 22px;
}

.hubicon-add_option.icon {
    grid-area: icon;
}

.phases-fair-play-settings__header .button {
    padding: 10px 12px;
    font-size: 18px;
}

.phases-group .phases-fair-play-settings__header .button {
    margin-bottom: 0;
}

.phases-fair-play-settings__header-menu-options {
    display: none;
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);    
    width: 340px;
    right: 16px;
    top: 54px;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    padding: 8px;
}

.phases-fair-play-settings__header-menu-options.show_menu {
    display: block;
}

.phases-fair-play-settings__header-menu-options__option {
    margin-bottom: 4px;
    padding: 8px;
    border-radius: 8px;
}

.phases-fair-play-settings__header-menu-options__option:hover{
    cursor: pointer;
    background-color: var(--new-background-color);
}

.phases-fair-play-settings__header-menu-options__option.baloa-names {
    color: var(--primary-very-dark-color);
}

.phases-fair-play-settings__select-row {
    border-bottom: 1px solid var(--new-gray-background-color);
    padding: 12px 24px;
}

.phases-fair-play-settings__select-row .baloa-table {
    color: var(--primary-very-dark-color);
}

.phases-fair-play-settings__select-control {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 14px 12px;
    max-width: 340px;
    margin-top: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.phases-fair-play-settings__select-control.baloa-names {
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.phases-fair-play-settings__select-control .hubicon-expand_more::before {
    font-size: 20px;
    color: var(--basic-gray-color);
}

.phases-fair-play-settings__select-control.disabled {
    cursor: not-allowed;
    pointer-events: none;
    color: var(--disabled-color);
}

.phases-fair-play-settings__resume-row {
    display: flex;
    padding: 12px 24px 16px 24px;
}

.phases-fair-play-settings__resume-column {
    width: 30%;
}

.phases-fair-play-settings__resume-column-2 {
    width: 70%;
}

.phases-fair-play-settings__resume-option__title.baloa-names{
    color: var(--primary-very-dark-color);
    margin-top: 17px;
}

.phases-fair-play-settings__resume-option:first-of-type .phases-fair-play-settings__resume-option__title.baloa-names {
    margin-top: 0;
}

.phases-fair-play-settings__resume-option__set.baloa-table {
    display: flex;
    color: var(--primary-very-dark-color);
    margin-top: 10px;
}

.phases-fair-play-settings__resume-option__set-card {
    text-transform: lowercase;
}

.phases-fair-play-settings__resume-option__set-value {
    margin-left: 4px;
    margin-right: 17px;
}

.phases-fair-play-settings__button-create {
    position: relative;
}

.phases-fair-play-settings__tooltip {
    visibility: hidden;

    width: 252px;
    padding: 12px;
    background-color: var(--white-color);
    color: var(--primary-very-dark-color);
    text-align: center;
    border-radius: 8px;
    position: absolute;
    z-index: 1;
    bottom: 146%;
    left: 0;
    margin-left: -78px;

    box-shadow: var(--shadow-card);
}

.phases-fair-play-settings__tooltip .baloa-table-column {
    color: var(--primary-very-dark-color);
}

.phases-fair-play-settings__tooltip::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin-left: -14px;
    bottom: -25px;
    left: 50%;
    box-sizing: border-box;
    border-width: 14px;
    border-style: solid;
    border-color:   transparent transparent var(--white-color)  var(--white-color);
    transform-origin: 0 0;
    transform: rotate(-45deg);
    z-index: -1;
    /* box-shadow: -1px 1px 1px 0 rgba(170, 193, 182, 0.32); */
    box-shadow: -1px 1px 1px 0px rgba(170, 193, 182, 0.32), -3px 3px 3px 0px rgba(192, 208, 214, 0.67);

    /* content: " ";
    position: absolute;
    top: 100%; 
    left: 50%;
    margin-left: -16px;
    border-width: 16px;
    border-style: solid;
    border-color: var(--white-color) transparent transparent  transparent ; */
}

.phases-fair-play-settings__button-create.disabled:hover .phases-fair-play-settings__tooltip {
    visibility: visible;
}

.phases-fair-play-settings__resume-option__set-group {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .phases-fair-play-settings__container {
        margin-top: 6px;
        margin-left: 10px;
        margin-right: 10px;
    }

    .phases-fair-play-settings__select-row {
        display: none;
    }

    .phases-fair-play-settings__resume-row {
        padding: 11px 24px;
        flex-direction: column;
    }

    .phases-fair-play-settings__resume-column {
        width: 100%;
    }

    .phases-fair-play-settings__resume-column-2 {
        width: 100%;
        margin-top: 24px;
    }

    .phases-fair-play-settings__resume-option__set.baloa-table.view-column {
        flex-direction: column;
    }

    .phases-fair-play-settings__resume-option__set-group {
        margin-top: 17px;
    }

    .phases-fair-play-settings__resume-option__set-group:first-child {
        margin-top: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-phases-fair-play-settings/TournamentPhasesFairPlaySettingsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yDAAyD;IACzD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,+CAA+C;IAC/C,YAAY;IACZ,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,kDAAkD;IAClD,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yDAAyD;IACzD,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;;IAElB,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,OAAO;IACP,kBAAkB;;IAElB,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,8EAA8E;IAC9E,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;IACX,0DAA0D;IAC1D,kGAAkG;;IAElG;;;;;;;6EAOyE;AAC7E;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".phases-fair-play-settings__container {\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    background: var(--white-color);\n    margin-top: 16px;\n}\n\n.phases-fair-play-settings__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding: 8px 16px;\n    position: relative;\n}\n\n.phases-fair-play-settings__header .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n}\n\n.phases-fair-play-settings__header .hubicon-add_option {\n    color: unset;\n    margin-right: 4px;\n    font-size: 22px;\n}\n\n.hubicon-add_option.icon {\n    grid-area: icon;\n}\n\n.phases-fair-play-settings__header .button {\n    padding: 10px 12px;\n    font-size: 18px;\n}\n\n.phases-group .phases-fair-play-settings__header .button {\n    margin-bottom: 0;\n}\n\n.phases-fair-play-settings__header-menu-options {\n    display: none;\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);    \n    width: 340px;\n    right: 16px;\n    top: 54px;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    padding: 8px;\n}\n\n.phases-fair-play-settings__header-menu-options.show_menu {\n    display: block;\n}\n\n.phases-fair-play-settings__header-menu-options__option {\n    margin-bottom: 4px;\n    padding: 8px;\n    border-radius: 8px;\n}\n\n.phases-fair-play-settings__header-menu-options__option:hover{\n    cursor: pointer;\n    background-color: var(--new-background-color);\n}\n\n.phases-fair-play-settings__header-menu-options__option.baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.phases-fair-play-settings__select-row {\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding: 12px 24px;\n}\n\n.phases-fair-play-settings__select-row .baloa-table {\n    color: var(--primary-very-dark-color);\n}\n\n.phases-fair-play-settings__select-control {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 14px 12px;\n    max-width: 340px;\n    margin-top: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n}\n\n.phases-fair-play-settings__select-control.baloa-names {\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.phases-fair-play-settings__select-control .hubicon-expand_more::before {\n    font-size: 20px;\n    color: var(--basic-gray-color);\n}\n\n.phases-fair-play-settings__select-control.disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n    color: var(--disabled-color);\n}\n\n.phases-fair-play-settings__resume-row {\n    display: flex;\n    padding: 12px 24px 16px 24px;\n}\n\n.phases-fair-play-settings__resume-column {\n    width: 30%;\n}\n\n.phases-fair-play-settings__resume-column-2 {\n    width: 70%;\n}\n\n.phases-fair-play-settings__resume-option__title.baloa-names{\n    color: var(--primary-very-dark-color);\n    margin-top: 17px;\n}\n\n.phases-fair-play-settings__resume-option:first-of-type .phases-fair-play-settings__resume-option__title.baloa-names {\n    margin-top: 0;\n}\n\n.phases-fair-play-settings__resume-option__set.baloa-table {\n    display: flex;\n    color: var(--primary-very-dark-color);\n    margin-top: 10px;\n}\n\n.phases-fair-play-settings__resume-option__set-card {\n    text-transform: lowercase;\n}\n\n.phases-fair-play-settings__resume-option__set-value {\n    margin-left: 4px;\n    margin-right: 17px;\n}\n\n.phases-fair-play-settings__button-create {\n    position: relative;\n}\n\n.phases-fair-play-settings__tooltip {\n    visibility: hidden;\n\n    width: 252px;\n    padding: 12px;\n    background-color: var(--white-color);\n    color: var(--primary-very-dark-color);\n    text-align: center;\n    border-radius: 8px;\n    position: absolute;\n    z-index: 1;\n    bottom: 146%;\n    left: 0;\n    margin-left: -78px;\n\n    box-shadow: var(--shadow-card);\n}\n\n.phases-fair-play-settings__tooltip .baloa-table-column {\n    color: var(--primary-very-dark-color);\n}\n\n.phases-fair-play-settings__tooltip::after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin-left: -14px;\n    bottom: -25px;\n    left: 50%;\n    box-sizing: border-box;\n    border-width: 14px;\n    border-style: solid;\n    border-color:   transparent transparent var(--white-color)  var(--white-color);\n    transform-origin: 0 0;\n    transform: rotate(-45deg);\n    z-index: -1;\n    /* box-shadow: -1px 1px 1px 0 rgba(170, 193, 182, 0.32); */\n    box-shadow: -1px 1px 1px 0px rgba(170, 193, 182, 0.32), -3px 3px 3px 0px rgba(192, 208, 214, 0.67);\n\n    /* content: \" \";\n    position: absolute;\n    top: 100%; \n    left: 50%;\n    margin-left: -16px;\n    border-width: 16px;\n    border-style: solid;\n    border-color: var(--white-color) transparent transparent  transparent ; */\n}\n\n.phases-fair-play-settings__button-create.disabled:hover .phases-fair-play-settings__tooltip {\n    visibility: visible;\n}\n\n.phases-fair-play-settings__resume-option__set-group {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .phases-fair-play-settings__container {\n        margin-top: 6px;\n        margin-left: 10px;\n        margin-right: 10px;\n    }\n\n    .phases-fair-play-settings__select-row {\n        display: none;\n    }\n\n    .phases-fair-play-settings__resume-row {\n        padding: 11px 24px;\n        flex-direction: column;\n    }\n\n    .phases-fair-play-settings__resume-column {\n        width: 100%;\n    }\n\n    .phases-fair-play-settings__resume-column-2 {\n        width: 100%;\n        margin-top: 24px;\n    }\n\n    .phases-fair-play-settings__resume-option__set.baloa-table.view-column {\n        flex-direction: column;\n    }\n\n    .phases-fair-play-settings__resume-option__set-group {\n        margin-top: 17px;\n    }\n\n    .phases-fair-play-settings__resume-option__set-group:first-child {\n        margin-top: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
